__webpack_require__.p = "/certificates/";